module.exports = __webpack_public_path__ + "static/media/sauldesign.b3ddc0b1.png";